<template>
    <vue-editor
        id="comment"
        useCustomImageHandler
        @image-added="handleImageAdded"
        @image-removed="handleRemoveImage"
        v-model="content"
        :editorOptions="editorSettings"
        ref="editorVue"
    >
    </vue-editor>
</template>
<script>
import {VueEditor, Quill} from "vue2-editor";
import {ImageDrop} from 'quill-image-drop-module';
import ImageResize from 'quill-image-resize-module';

Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/imageResize', ImageResize)
export default {
    name: "vue-text-editor",
    props: ['textBinding'],
    components: {
        VueEditor
    },
    data() {
        return {
            editorSettings: {
                modules: {
                    imageDrop: true,
                    imageResize: {
                        modules: ['Resize', 'DisplaySize', 'Toolbar']

                    }
                }
            },
        }
    },
    computed: {
        content: {
            get: function () {
                return this.textBinding;
            },
            set: function (newValue) {
                console.log('newValue',newValue);
                this.$emit('emailBodyText',newValue);
                return newValue;
            }
        },
    },
    methods: {
        handleImageAdded: function (file, Editor, cursorLocation, resetUploader) {
            // An example of using FormData
            // NOTE: Your key could be different such as:
            // formData.append('file', file)
            const formData = new FormData();
            formData.append("image", file);
            console.log('formdata', formData);
            axios.post(route('api.editor-image-upload'), formData).then(result => {
                const url = result.data.data; // Get url from response
                Editor.insertEmbed(cursorLocation, "image", url);
                resetUploader();
            }).catch(err => {
                console.log(err);
            });
        },
        handleRemoveImage: function (file, Editor, cursorLocation, resetUploader){
            console.log('remove file', file);
            axios.post(route('api.editor-image-remove'), {'filePath':file}).then(result => {
                console.log('remove',result);
            }).catch(err => {
                console.log(err);
            });
        }
    },
    mounted() {
        const editorContent = this.$refs.editorVue.$el.querySelector('[contenteditable="true"]');
        if (editorContent) {
            editorContent.setAttribute('spellcheck', 'true');
        }
    }
}
</script>
<style>
#comment {
    max-height: 300px !important;
    overflow: auto;
}
</style>
